import urlHelper from './urlHelper'
import axios from 'axios'
import qs from 'querystring'

export default {
  validateLogoutSamlResponse (samlResponse) {
    const validateUrl = process.env.APP_BASE + '/api/logout?samlResponse=' + samlResponse
    return axios.post(validateUrl)
  },
  logoutUrl () {
    var url = urlHelper('/api/logout')
    return axios.get(url).then(response => response.data.redirect)
  },
  // Ber om SamlRequest fra API og sender med Url for validering og redirecting av response
  ssoLoginUrl (bookId, redirect) {
    var redirectToNode = location.origin + process.env.APP_BASE + '/loginfromsso' + '?bookId=' + bookId + '&redirect=' + redirect
    return axios.get(process.env.APP_BASE + '/api/loginsaml?' + qs.stringify({bookid: bookId, redirect: redirectToNode})).then(r => r.data.redirect)
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js